// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import WalletTwoToneSvg from "@fishx/icons-svg/es/asn/WalletTwoTone";
import FishxIcon from '../components/FishxIcon';

var WalletTwoTone = function WalletTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: WalletTwoToneSvg
  }));
};

WalletTwoTone.displayName = 'WalletTwoTone';
export default React.forwardRef(WalletTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/WalletTwoTone.js
// module id = 4386
// module chunks = 0